import React from 'react'
import './HeaderSecond.css'
import { useTranslation } from 'react-i18next';
const HeaderSecond = () => {
  const { t } = useTranslation();
  return (
    <>
        <header className='HeaderSecond mt-5'>
            <div className="container">
                <h1 className='main-h1'>{t('header_second.title')}</h1>
                <p className='sub-p'>{t('header_second.desc')}</p>
                <div className="d-flex justify-content-center gap-3">
                  <a href="#join" className="btn btn-outline-light w-200px py-2 d-flex align-items-center justify-content-center text-decoration-none">
                    {t('hero.partner_btn')}
                  </a>
                  <a href="#contact" className="contact-btn rounded-1 py-2 d-flex align-items-center justify-content-center text-decoration-none">
                    {t('nav.contact_us')}
                  </a>
                </div>
            </div>
        </header>
    </>
  )
}

export default HeaderSecond